import React, { useEffect, useState } from "react";
import DashboardFilterForSmbAndFiber from "../../components/dashboardFilterForSmbAndFiber";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPayoutCsvSmbAndFiber,
  fetchPayoutDashboardSmbAndFiber,
  fetchShowAlertPayout,
  hideAlertPayout,
  hideError,
  setSelectedData,
  showError,
  triggerDashboardAudit,
  triggerFetchTimeStampPayout,
  triggerIsDashboardAccessible,
} from "../../redux/actions";
import { filterNames } from "../../utils/constants";
import Spinner from "../../components/presentationals/Spinner";
import config from "../../utils/config";
import PayoutDashboardView from "../../views/payoutDashboard";
import {
  setPayoutDashboard,
  unsetPayoutDashboard,
  triggerShowHeader,
} from "../../redux/actions/action";
import CustomLandingBody from "../../components/customLandingBody";
import { ExportToCsv } from "export-to-csv";
import { checkPayoutCsv, isEmptyObject } from "../../utils/common";
import { payoutSmbFiberCsvMapping } from "../../utils/common/csvMappings/smbFiberPayout";

const Payout = () => {
  const dispatch = useDispatch();
  const {
    getAllAPI,
    tilesData,
    partnerRoleType,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    error,
  } = useSelector((state) => state.homeReducer);

  const { dashboardAccessibility } = useSelector(
    (state) => state?.dashboardAccessibilityReducer,
  );

  const { selectedData } = useSelector((state) => state.Ed1AndEd2Reducer);

  const [timestamp, setTimestamp] = useState({});

  const [dashboardData, setDashboardData] = useState({
    loading: false,
    data: null,
    error: null,
  });
  const [csvLoading, setCsvLoading] = useState({
    header: false,
    line: false,
  });

  const [showAlert, setShowAlert] = useState(null);
  const dashboardName = "Payout Dashboard";
  let payoutModules = getAllAPI?.data?.content?.filter(
    (row) => row.moduleName.toLowerCase() === filterNames.payout.toLowerCase(),
  )[0];
  const splittedScheme = selectedData?.["Scheme Name"].split(" - ");

  let payoutTiles = payoutModules?.modSecMasterTxDtos[0]?.secTilesMasterTxDtos;

  const changeHandler = (type, value) => {
    dispatch((dispatch, getState) => {
      const currentSelectedData = getState().Ed1AndEd2Reducer.selectedData;

      if (type === "Partner Name") {
        dispatch(
          setSelectedData({
            ...currentSelectedData,
            [type]: value,
            "Scheme Type": "",
            "Scheme Name": "",
          }),
        );
      } else if (type === "State") {
        dispatch(
          setSelectedData({
            ...currentSelectedData,
            [type]: value,
            "Partner Name": {},
            "Scheme Type": "",
            "Scheme Name": "",
          }),
        );
      } else if (type === "Region") {
        dispatch(
          setSelectedData({
            [type]: value,
            State: "",
            "Partner Name": {},
            "Scheme Type": "",
            "Scheme Name": "",
          }),
        );
      } else if (type === "Scheme Type") {
        dispatch(
          setSelectedData({
            ...currentSelectedData,
            [type]: value,
            "Scheme Name": "",
          }),
        );
      } else if (type === "Scheme Name") {
        dispatch(
          setSelectedData({
            ...currentSelectedData,
            [type]: value,
          }),
        );
      }
    });
  };

  const getPayoutDashboardData = () => {
    const obj = {
      headers: {
        url: "/smb-fiber-payout-dashboard",
      },
      params: {
        fromDate: headerSelectedDateFrom,
        isRedisActive: "YES",
        partnerId: config.validateRoleTypes?.[partnerRoleType].businessType
          ? selectedData?.["Partner Name"]?.partnerName?.split(" - ")?.[2]
          : filterValue.orgId !== ""
            ? filterValue.orgId
            : filterValue.agentId,
        ...(splittedScheme[0] !== "ALL" && { schemeName: splittedScheme[1] }),
        ...(splittedScheme[0] !== "ALL" && { schemeNo: splittedScheme[2] }),
        schemeType: selectedData?.["Scheme Type"],
        toDate: headerSelectedDateTo,
      },
    };
    setDashboardData({
      loading: true,
      data: null,
      error: null,
    });
    dispatch(
      fetchPayoutDashboardSmbAndFiber(
        obj,
        (res) => {
          // console.log(res);
          setDashboardData({
            loading: false,
            data: res?.content,
            error: null,
          });
        },
        (err) => {
          setDashboardData({
            loading: false,
            data: null,
            error: err,
          });
        },
      ),
    );
  };

  const sendAudit = (viewName) => {
    const obj = {
      headers: {
        url: "/add-dashboard-audit",
      },
      params: {
        action: "download",
        dashboard: dashboardName,
        empId: filterValue?.orgId?.length
          ? filterValue?.orgId
          : filterValue?.agentId,
        empRole: filterValue.partnerName,
        remarks: "Dashboard Audit request",
        userType: filterValue?.site,
        viewName: viewName,
      },
    };
    triggerDashboardAudit(obj);
  };

  const fetchCsv = (option) => {
    sendAudit(option === "line" ? "Quantity" : "Payout");
    const obj = {
      headers: {
        url:
          option === "header"
            ? "/smb-fiber-payout-header-csv"
            : "/smb-fiber-payout-line-csv",
      },
      params: {
        fromDate: headerSelectedDateFrom,
        partnerId: config.validateRoleTypes?.[partnerRoleType].businessType
          ? selectedData?.["Partner Name"]?.partnerName?.split(" - ")?.[2]
          : filterValue.orgId !== ""
            ? filterValue.orgId
            : filterValue.agentId,
        ...(splittedScheme[0] !== "ALL" && { schemeName: splittedScheme[1] }),
        ...(splittedScheme[0] !== "ALL" && { schemeNo: splittedScheme[2] }),
        schemeType: selectedData?.["Scheme Type"],
        toDate: headerSelectedDateTo,
      },
    };
    let options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      filename:
        option === "line"
          ? `${filterValue?.selectedPartnerRoleName ?? ""}LineItemDetails`
          : `${filterValue?.selectedPartnerRoleName ?? ""}HeaderItemDetails`,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };
    let csvExporter = new ExportToCsv(options);
    let filteredCsv;
    if (checkPayoutCsv(headerSelectedDateFrom, headerSelectedDateTo)) {
      if (option === "line") {
        setCsvLoading((prev) => {
          return {
            ...prev,
            line: true,
          };
        });
        return dispatch(
          fetchPayoutCsvSmbAndFiber(
            obj,
            (response, params) => {
              setCsvLoading((prev) => {
                return {
                  ...prev,
                  line: false,
                };
              });
              if (response.content.length) {
                csvExporter.generateCsv(
                  payoutSmbFiberCsvMapping("lineItem", response.content),
                );
              } else {
                dispatch(fetchShowAlertPayout("Payout"));
                setTimeout(() => {
                  dispatch(hideAlertPayout());
                }, 5000);
              }
            },
            (error, params) => {
              setCsvLoading((prev) => {
                return {
                  ...prev,
                  line: false,
                };
              });
              dispatch(showError());
              dispatch(fetchShowAlertPayout("Payout"));
              setTimeout(() => {
                dispatch(hideAlertPayout());
                dispatch(hideError());
              }, 5000);
            },
          ),
        );
      } else {
        setCsvLoading((prev) => {
          return {
            ...prev,
            header: true,
          };
        });
        return dispatch(
          fetchPayoutCsvSmbAndFiber(
            obj,
            (response, params) => {
              setCsvLoading((prev) => {
                return {
                  ...prev,
                  header: false,
                };
              });
              if (response.content.length) {
                csvExporter.generateCsv(
                  payoutSmbFiberCsvMapping("header", response.content),
                );
              } else {
                dispatch(fetchShowAlertPayout("Payout"));
                setTimeout(() => {
                  dispatch(hideAlertPayout());
                }, 5000);
              }
            },
            (error, params) => {
              setCsvLoading((prev) => {
                return {
                  ...prev,
                  header: false,
                };
              });
              dispatch(showError());
              dispatch(fetchShowAlertPayout("Payout"));
              setTimeout(() => {
                dispatch(hideAlertPayout());
                dispatch(hideError());
              }, 5000);
            },
          ),
        );
      }
    } else {
      alert("date range should not be more than 7 days");
    }
  };

  const runButtonClickHandler = () => {
    getPayoutDashboardData();
  };

  useEffect(() => {
    setDashboardData({
      loading: false,
      data: null,
      error: null,
    });
  }, [headerSelectedDateFrom, headerSelectedDateTo, selectedData]);

  // useEffect(() => {
  //   console.log(isEmptyObject(selectedData?.['Partner Name']) , selectedData?.['Scheme Type'] , selectedData?.['Scheme Name']);
  //   if(!isEmptyObject(selectedData?.['Partner Name']) && selectedData?.['Scheme Type']!== '' && selectedData?.['Scheme Name']!== ''){
  //     getPayoutDashboardData();
  //   }
  // },[])

  useEffect(() => {
    const setPayoutDashboardForCalender = () => {
      return dispatch(setPayoutDashboard());
    };
    setPayoutDashboardForCalender();
    return () => {
      dispatch(unsetPayoutDashboard());
    };
  }, [dispatch]);

  useEffect(() => {
    function fetchTimeStamp() {
      return dispatch(
        triggerFetchTimeStampPayout(
          {
            headers: {
              url: "/get-updated-timestamp",
            },
          },
          (res) => {
            setTimestamp(res?.content);
          },
          (err) => {
            // console.log(err);
          },
        ),
      );
    }
    fetchTimeStamp();
  }, []);

  useEffect(() => {
    const showHeader = () => {
      return dispatch(triggerShowHeader(true));
    };

    //check if isTestingActive is true, then send api call for triggerIsDashboardAccessible
    let isTestingActive = tilesData?.data?.content?.filter(
      (obj) =>
        obj?.moduleName?.toLowerCase() === filterNames?.payout?.toLowerCase(),
    )[0]?.isTestingActive;

    //if it is true, then check if this logged in user has access to this dashboard
    if (isTestingActive) {
      //to check if the response for this dashboard api call is already cached in redux
      let isExistingDashboard = dashboardAccessibility?.data?.filter(
        (currentDashboard) => currentDashboard.dashboard === dashboardName,
      );

      //if dashboard accessibility is already cached and accessEnabled is false, means directly show alert without sending api call again
      if (
        isExistingDashboard.length > 0 &&
        !isExistingDashboard[0]?.isDashboardAccessible?.accessEnabled
      ) {
        // load dashboardcard home component and show alert
        return setShowAlert(true);
      }

      // if dashboard accessibility is cached and accessEnabled is true, do not send api call, do not show alert BUT SHOW DASHBOARD NORMALLY
      else if (
        isExistingDashboard.length > 0 &&
        isExistingDashboard[0]?.isDashboardAccessible?.accessEnabled
      ) {
        setShowAlert(false);
        showHeader();
      }

      //if dashboard accessibility is not cached already then send api call for this dashboard
      else {
        const data = {
          baseParameter: {
            name: dashboardName,
            userType: filterValue.site,
          },
          domainId:
            filterValue.orgId !== "" ? filterValue.orgId : filterValue?.agentId,
        };

        const obj = {
          headers: {
            "Content-Type": "application/json",
            url: "get-dashboard-user-role-mapping",
          },
          params: data,
          extraData: "get-dashboard-user-role-mapping",
        };

        return dispatch(
          triggerIsDashboardAccessible(obj, (res) => {
            //if the response shows access enabled as false, go to home page and show alert
            if (!res.content.accessEnabled) {
              setShowAlert(true);
            } else {
              setShowAlert(false);
              showHeader();
            }
          }),
        );
      }
    }

    //if isTestingActive is false, it is open for all users
    else {
      setShowAlert(false);
      showHeader();
    }
  }, [getAllAPI]);

  return showAlert === null ? (
    <Spinner />
  ) : showAlert ? (
    <CustomLandingBody showAlert={showAlert} dashboardName={dashboardName} />
  ) : (
    <div className="container-fluid">
      <DashboardFilterForSmbAndFiber
        changeHandler={changeHandler}
        runButtonClickHandler={runButtonClickHandler}
        dashboardMenu={config.SmbAndFiberFilterFormConfForPayout}
        type={dashboardName}
        data={dashboardData}
      />
      <PayoutDashboardView
        dashboardData={dashboardData}
        payoutTiles={payoutTiles}
        payoutModules={payoutModules}
        fetchCsv={fetchCsv}
        csvLoading={csvLoading}
        timestamp={timestamp}
        error={error}
      />
    </div>
  );
};

export default Payout;
